import { apiRequest } from "@portal/lib/ky/utils";
import { LoginDTO, LoginDTOResponse } from "@portal/types/entities/login";

export async function loginSendOTP(data: LoginDTO) {
  const response = await apiRequest<LoginDTO, LoginDTOResponse>({
    method: "POST",
    url: "v1/auth/send-otp",
    data,
  });
  return await response.json();
}

export async function loginVerifyOTP(data: LoginDTO) {
  const response = await apiRequest<LoginDTO, { url: string }>({
    method: "POST",
    url: "v1/auth/verify-otp",
    data,
  });
  return await response.json();
}

export async function logOut() {
  return await apiRequest<undefined, undefined>({
    method: "GET",
    url: "v1/auth/logout",
  });
}
